import { memo,useState,useEffect } from "react";
import ImageFetch from "./ImageFetch";
import { ClipLoader } from "react-spinners";

const AssetsList = ({selectedCategory,selectedStickerPack, addAssets}) => {  
    const [loader,setLoader] = useState(true)
    const [reRender,setRerender] = useState(false)
    const incrementLoader = () => {
        setLoader(false)
    }
    useEffect(()=>{
        setLoader(true)
        setRerender(!reRender)
    },[selectedStickerPack])
    return (       
        <div className={`stickers ${loader?"loading":""}`}>
                {
                <>
                {loader?<div className="loader"></div>:<></>}
                {selectedStickerPack?.map((sticker, index) => (
                  <ImageFetch addAssets={addAssets} link={sticker.image} incrementLoader = {incrementLoader} imagesLoaded={!loader} reRender={reRender}/>
                ))}
                </>
                }
              </div>
    )
}
export default memo(AssetsList)